import React from "react";
// --- MODIFICATION 1: useState is no longer needed ---
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "./OurTeam.css";

// --- Step 1: Import motion from Framer Motion ---
import { motion } from "framer-motion";

// --- Step 2: (Best Practice) Organize team data into an array ---
const teamMembers = [
  {
    name: "Mr Ashutosh Hota",
    role: "Secretary-cum-CEO",
    image: "assets/images/team/team1.jpg",
  },
  {
    name: "Mr Karunakar Parhi",
    role: "Finance Head",
    image: "assets/images/team/team-2.jpg",
  },
  {
    name: "Mr Susanta Kumar Behera",
    role: "Programme Manager-Homes",
    image: "assets/images/team/team-3.jpg",
  },
  {
    name: "Ms Sushma Arora",
    role: "Programme Manager-Disability",
    image: "assets/images/team/team-4.jpg",
  },
  {
    name: "Mr Asit Kumar Sahoo",
    role: "Program Manager",
    image: "assets/images/team/team-5.jpg",
  },
  {
    name: "Mr. Birajasankar Barik",
    role: "Program Manager",
    image: "assets/images/team/biraja.jpeg",
  },
  
  // Add other team members here if you have more
];

// --- Step 3: Define animation variants for the container and items ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Adds a 0.2s delay between each card's animation
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 }, // Start invisible and 50px down
  visible: { opacity: 1, y: 0 }, // Animate to visible and original position
};

const OurTeam = () => {
  // --- MODIFICATION 2: Removed the useState hook ---

  return (
    <>
      <Header />

      {/*Start Page Header*/}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(assets/images/backgrounds/vikashT.jpg)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img
            src="assets/images/shapes/page-header-shape1.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="shape2">
          <img
            src="assets/images/shapes/page-header-shape2.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="container">
          <div className="page-header__inner">
            {/* --- ANIMATION ADDED to Header Text --- */}
            <motion.h2
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              Our Team
            </motion.h2>
            <motion.p
              style={{ color: "#dad2d0", fontSize: "24px", marginTop: "20px" }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              Our passionate team is dedicated to empowering <br /> marginalized
              communities through healthcare, <br /> education, and sustainable
              development.
            </motion.p>
          </div>
        </div>
      </section>
      {/*End Page Header*/}

      <section className="team-one">
        <div
          className="team-one__pattern"
          style={{
            backgroundImage: "url(assets/images/pattern/team-v1-pattern.png)",
          }}
        ></div>
        <div className="shape1 float-bob-y">
          <img src="assets/images/shapes/team-v1-shape1.png" alt="" />
        </div>
        <div className="container">
          <div className="sec-title text-center">
            <div className="sec-title__tagline center">
              <div className="left-line" />
              <div className="right-line" />
            </div>
            {/* --- ANIMATION ADDED to Section Title --- */}
            <motion.h2
              className="sec-title__title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Our Team Members
            </motion.h2>
          </div>

          {/* --- Step 4: Apply variants to the row and map through the data --- */}
          <motion.div
            className="our-team-members-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }} // Animate when 20% of the container is visible
          >
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                className="col-xl-4 col-lg-6 col-md-6"
                variants={cardVariants}
              >
                <motion.div
                  className="team-card"
                  whileHover={{ y: -8, scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 350, damping: 18 }}
                >
                  <div className="team-card__avatar">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="team-card__body">
                    <h3 className="team-card__name">{member.name}</h3>
                    <p className="team-card__role">{member.role}</p>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <Footer />
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
export default OurTeam;